import { useTranslation } from 'react-i18next';
import { useUndoSnapshot } from '../hooks/useUndo';
import { CloseIcon } from '../ui/icons';
import styles from './Toasts.module.css';
import { cx } from '../lib/cx';
import { ToastKind, useToastStore } from './toastStore';

export function Toasts() {
  const { t } = useTranslation();
  const toasts = useToastStore((state) => state.toasts);
  const dismiss = useToastStore((state) => state.dismiss);
  const { version } = useUndoSnapshot();

  return (
    <div className={styles.region} aria-live="polite" data-testid="toasts">
      {toasts.map((toast) => {
        const actionValid =
          toast.action !== undefined && (toast.undoVersion === undefined || toast.undoVersion === version);
        return (
          <div
            key={toast.id}
            className={cx(styles.toast, toast.kind === ToastKind.Error && styles.error)}
            role={toast.kind === ToastKind.Error ? 'alert' : 'status'}
          >
            <span className={styles.message}>{toast.message}</span>
            {actionValid && toast.action !== undefined ? (
              <button
                type="button"
                className={styles.action}
                onClick={() => {
                  toast.action?.onAction();
                  dismiss(toast.id);
                }}
              >
                {toast.action.label}
              </button>
            ) : null}
            <button
              type="button"
              className={styles.close}
              aria-label={t('toast.dismiss')}
              onClick={() => dismiss(toast.id)}
            >
              <CloseIcon />
            </button>
          </div>
        );
      })}
    </div>
  );
}
